export const bannedPasswordParts: string[] = ['welcome', 'kixie', 'test'];
